<template>
    <div class="video-pre el-container">
        <div ref="live" class="video"></div>
    </div>
</template>

<script>
    export default {
        name: "videopre",
        props:['id'],
        watch: {
            'id': function (newVal) {
                if (newVal) {
                    let url = 'https://gcik47gyt746q6nqdze.exp.bcevod.com/'+ newVal +'/'+ newVal +'.m3u8'
                    this.playVideo(url)
                }
            }
        },
        methods:{
            playVideo:function(video_url){
                var player = cyberplayer(this.$refs.live).setup({
                    width: 575,
                    height: 450,
                    stretching: "uniform",
                    file: video_url,
                    marquee:{show : false ,text:'中公网校',fontSize:20,color:'#990033'},
                    primary: "flash",
                    repeat: false,
                    volume: 100,
                    controls: true,
                    controlbar: {
                        barLogo: false, // 进度条上的logo显示与否,默认true

                    },
                    ak: '77f99df9002b4bb8be40288a9ca80e6b'
                });
            }
        },
        mounted () {
            if (this.id) {
                let url = 'https://gcik47gyt746q6nqdze.exp.bcevod.com/'+ this.id +'/'+ this.id +'.m3u8'
                this.playVideo(url)
            }
        }
    }
</script>
<style scoped>
    .video-pre{
        width: 100%;
        flex-direction: column;
        position: relative;
        align-items: center;
    }
    header{
        display: flex;
        width:100%;
        align-items: center;
        justify-content: center;
        vertical-align: middle;
        padding: 30px 0 28px;
        background-color: #fff;
        margin-bottom: 0px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/video-previews/index.vue